module.exports = __webpack_public_path__ + "img/client16.561ec6fd.svg";